import React, { Component } from 'react'
import { UploadFileRepository, Loading, Button, Checkbox, Combobox, DatePicker, Input, Alert } from '..';
import { GLOBAL } from '../../Config/global';
import { APPCONFIG } from '../../app.config';
import { DEFAULT_HEADER } from '../../Config/userToken';
import * as QLIBS from '../../qLibsHelpers';
import moment from "moment";


export default class CommunicationModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            id: this.props.id,
            loadingData: false,
            showForm: false,
            errorMessage: null,
            entity: null,
            textSendMailDate: ''
        }

        this.getCommunication = this.getCommunication.bind(this);
        this.clearCommunication = this.clearCommunication.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleComboChange = this.handleComboChange.bind(this);
        this.handleCommunicationBody = this.handleCommunicationBody.bind(this);
        this.handleCommunicationAttach = this.handleCommunicationAttach.bind(this);
        this.refreshFilesCommunication = this.refreshFilesCommunication.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {

        if (this.state.id === 0) {
            this.clearCommunication(); 
        }
        else {
           this.getCommunication(this.state.id); 
        }

    }

	getCommunication = (id) => {
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

		this.setState({loadingData: true, showForm: false, errorMessage: null, entity: null });

		const requestOptions = {
			method: 'GET',
			headers: DEFAULT_HEADER.get()
		};			
		return fetch(`${PRODUCERURL}api/communication/getcommunication?id=${id}`, requestOptions)
		.then((response) => {

			if (response.ok) {
				QLIBS.authorizeAction(response)
				.then((response) => {
                    const entity = response;
                    if (entity.endDate === null) entity.endDate = '';
                    if (entity.sendMailDate === null) entity.sendMailDate = '';
                    if (entity.confirmationText === null) entity.confirmationText = '';

                    let textSendMailDate = '';
                    if (entity.sendMailDate !== '') {
                        const fecha = moment(entity.sendMailDate).format("DD/MM/YYYY");
                        textSendMailDate = `Fecha de último aviso: ${fecha}`;
                    }

                    this.setState({ loadingData: false, showForm: true, entity: entity, textSendMailDate: textSendMailDate });
                })
				.catch((response) => {
                    const message = 'Error procesando datos';
                    this.setState({ loadingData: false, showForm: false, errorMessage: message });
                });
			}
			else {
				const message = `Error procesando solicitud: ${response.statusText}`;
				this.setState({ loadingData: false, showForm: false, errorMessage: message });
			}

		});
	}

	refreshFilesCommunication = (id) => {
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

		this.setState({loadingData: true, showForm: false, errorMessage: null});

		const requestOptions = {
			method: 'GET',
			headers: DEFAULT_HEADER.get()
		};			
		return fetch(`${PRODUCERURL}api/communication/getcommunication?id=${id}`, requestOptions)
		.then((response) => {

			if (response.ok) {
				QLIBS.authorizeAction(response)
				.then((response) => {

                    let entity = {...this.state.entity};
                    entity.urlBody = response.urlBody;
                    entity.urlLink = response.urlLink;

                    this.setState({ loadingData: false, showForm: true, entity: entity });
                })
				.catch((response) => {
                    const message = 'Error subiendo archivo';
                    this.setState({ loadingData: false, showForm: true, errorMessage: message });
                });
			}
			else {
				const message = `Error procesando solicitud: ${response.statusText}`;
				this.setState({ loadingData: false, showForm: true, errorMessage: message });
			}

		});
	}

    clearCommunication = () => {

        const entity = {
            priority: 1,
            description: '',
            title: '',
            urlBody: undefined,
            urlLink: undefined,
            confirmationText: '',
            enabled: false,
            sendMail: false,
            confirmationRequired: false,
            bodyEmbedded: false,
            startDate: new Date(),
            endDate: '',
            sendMailDate: '',
        };
        this.setState({ loadingData: false, showForm: true, entity: entity });
    }

    validar() {
        const entity = {...this.state.entity};
        if (!entity.priority || !entity.description || !entity.title || !entity.startDate) {
            this.setState({ errorMessage: 'Debe completar todos los campos obligatorios' });
            return false;
        }
        if (entity.confirmationRequired && !entity.confirmationText) {
            this.setState({ errorMessage: 'Debe completar todos los campos obligatorios' });
            return false;
        }

        return true;
    }


    handleSubmit = (isNew) => {

        if (this.validar()) {
            const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

            let data = {...this.state.entity};
            
            //normalizo los campos sin datos
            if (data.endDate === '') data.endDate = null;
            if (data.sendMailDate === '') data.sendMailDate = null;
            if (data.confirmationText === '') data.confirmationText = null;

            this.setState({loadingData: true, showForm: false, errorMessage: null });

            const requestOptions = {
                method: isNew ? 'POST' : 'PUT',
                headers: DEFAULT_HEADER.get(),
                body: JSON.stringify(data)
            };	
            return fetch(`${PRODUCERURL}api/Communication/`, requestOptions)
            .then((response) => {

                if (response.ok) {
                    QLIBS.authorizeAction(response)
                    .then((id) => {
                        if (isNew) {
                            this.setState({ id: id, loadingData: false, entity: null, errorMessage: null }, () => {
                                this.getCommunication(this.state.id);
                            });
                        }
                        else {
                            this.setState({ loadingData: false, showForm: false, entity: null, errorMessage: null });
                            this.props.dismiss(true);
                        }
                    })
                    .catch((response) => {
                        const message = 'Error procesando datos';
                        this.setState({ loadingData: false, showForm: false, errorMessage: message });
                    });
                }
                else {
                    const message = `Error procesando solicitud: ${response.statusText}`;
                    this.setState({ loadingData: false, showForm: false, errorMessage: message });
                }

            });
        }

    }


    handleInputChange = event => {
        const isCheckbox = event.target.type === "checkbox";

        let inputName = event.target.name ? event.target.name : event.target.id;
        let inputValue = isCheckbox ? event.target.checked : event.target.value;

        let entity = {...this.state.entity};
        switch (inputName) {
            case "ctlDescription":
                entity.description = inputValue;
                break;
            case "ctlTitle":
                entity.title = inputValue;
                break;
            case "ctlUrlBody":
                entity.urlBody = inputValue;
                break;
            case "ctlUrlLink":
                entity.urlLink = inputValue;
                break;
            case "ctlConfirmationText":
                entity.confirmationText = inputValue;
                break;
            case "ctlEnabled":
                entity.enabled = inputValue;
                break;
            case "ctlSendMail":
                entity.sendMail = inputValue;
                break;
            case "ctlConfirmationRequired":
                entity.confirmationRequired = inputValue;
                if (!entity.confirmationRequired) {
                    entity.confirmationText = '';
                }
                break;
            case "ctlBodyEmbedded":
                entity.bodyEmbedded = inputValue;
                break;
            default:
                break;
        }

        this.setState({ entity: entity });
    };

    handleDatePickerChange = event => {
        let inputName = event.target.name ? event.target.name : event.target.id;
        let inputValue = event.target.value;

        if (inputValue !== '') {
            inputValue = new Date(inputValue);
        }

        let entity = {...this.state.entity};
        switch (inputName) {
            case "ctlStartDate":
                entity.startDate = inputValue;
                break;
            case "ctlEndDate":
                entity.endDate = inputValue;
                break;
            default:
                break;
        }

        this.setState({ entity: entity });
    };

    handleComboChange = (selectedOption, event, index) => {
        let inputName = event.name;
        let inputValue = selectedOption.value;

        let entity = {...this.state.entity};
        switch (inputName) {
            case "ctlPriority":
                entity.priority = inputValue;
                break;
            default:
                break;
        }

        this.setState({ entity: entity });
    };

    handleCommunicationBody = () => {
        this.refreshFilesCommunication(this.state.id);
    }

    handleCommunicationAttach = () => {
        this.refreshFilesCommunication(this.state.id);
    }

    render() {
        const { COMMON_MODAL_FORM } = GLOBAL;

        return (
		    <>
                <Loading visible={this.state.loadingData}></Loading>

                <div id="form-communication" className="modal" tabIndex="-1" role="dialog"  aria-modal="true">
                    <div className="modal-dialog modal-lg m-b-modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title text-center">Definición de Comunicación</h4>
                            </div>
                            <div className="modal-body">

                                {this.state.errorMessage && (<Alert type="error" title="ERROR" message={this.state.errorMessage} noDetail={true} />)}
                                {this.state.showForm && (
                                 <section>
                                     <div className="row pb-4">
                                        <div className="col-12 pt-3 text-left">
                                            <Checkbox
                                                id="ctlEnabled"
                                                text="Habilitar la visualización de la comunicación"
                                                checked={this.state.entity.enabled}
                                                onChange={this.handleInputChange}
                                                smallPrint=""
                                                disabled={(this.state.id === 0)}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <Input
                                                id="ctlDescription"
                                                type="text"
                                                text={"Descripción (*)"}
                                                defaultValue={this.state.entity.description}
                                                classes="mb-0"
                                                maxLength="1000"
                                                onChange={this.handleInputChange}
                                                smallPrint="Es la descripción general de la comunicación"
                                            />
                                        </div>
                                     </div>
                                    <div className="row pb-4">

                                        <div className="col-12">
                                            <Input
                                                id="ctlTitle"
                                                type="text"
                                                text={"Título de la comunicación (*)"}
                                                defaultValue={this.state.entity.title}
                                                classes="mb-0"
                                                maxLength="1000"
                                                onChange={this.handleInputChange}
                                            />
                                        </div>

                                        <div className="col-4 pt-3">
                                            <Combobox
                                                id="ctlPriority"
                                                label={"Prioridad (*)"}
                                                options={[
                                                    { value: 1, label: "Baja" },
                                                    { value: 2, label: "Regular" },
                                                    { value: 3, label: "Alta" }
                                                ]}
                                                onChange={(v, e) => { this.handleComboChange(v, e); }}
                                                defaultValue={this.state.entity.priority}
                                            />
                                        </div>
                                        <div className="col-4 pt-3">
                                            <label className="pb-10px">{"Vigencia desde (*)"}</label>
                                            <DatePicker
                                                id="ctlStartDate"
                                                maxLength="10"
                                                noDefaultValue="true"
                                                onChange={this.handleDatePickerChange}
                                                defaultValue={this.state.entity.startDate.toString()}
                                                disabled={(this.state.id !== 0 && (new Date(this.state.entity.startDate)).getTime() <= (new Date()).getTime())}
                                            />
                                        </div>
                                        <div className="col-4 pt-3">
                                            <label className="pb-10px">{"Vigencia hasta"}</label>
                                            <DatePicker
                                                id="ctlEndDate"
                                                maxLength="10"
                                                noDefaultValue="true"
                                                onChange={this.handleDatePickerChange}
                                                defaultValue={this.state.entity.endDate.toString()}
                                            />
                                        </div>

                                        {this.state.id !== 0 && (
                                        <>
                                        <div className="col-12 pt-3">
                                            <Input
                                                id="ctlUrlBody"
                                                type="text"
                                                text={"Link al contenido de la comunicación (*)"}
                                                defaultValue={this.state.entity.urlBody}
                                                classes="mb-0"
                                                maxLength="1000"
                                                //onChange={this.handleInputChange}
                                                readOnly={true}
                                                smallPrint="Es un link al contenido a mostrar en la comunicación"
                                            />
                                            <UploadFileRepository
                                                entity="CommunicationBody"
                                                entityId={this.state.entity.id.toString()}
                                                multiple={false}
                                                callbackDone={() => this.handleCommunicationBody()}
                                            />
                                        </div>
                                        <div className="col-12 pt-3 text-left">
                                            <Checkbox
                                                id="ctlBodyEmbedded"
                                                text="El contenido de la comunicación es un objeto embebido"
                                                checked={this.state.entity.bodyEmbedded}
                                                onChange={this.handleInputChange}
                                                smallPrint=""
                                            />
                                        </div>
                                        <div className="col-12 pt-3">
                                            <Input
                                                id="ctlUrlLink"
                                                type="text"
                                                text={"Link al documento adjunto"}
                                                defaultValue={this.state.entity.urlLink}
                                                classes="mb-0"
                                                maxLength="1000"
                                                //onChange={this.handleInputChange}
                                                readOnly={true}
                                                smallPrint="Es un link al documento adjunto de la comuniación"
                                            />
                                            <UploadFileRepository
                                                entity="CommunicationAttach"
                                                entityId={this.state.entity.id.toString()}
                                                multiple={false}
                                                callbackDone={() => this.handleCommunicationAttach()}
                                            />
                                        </div>
                                        </>
                                        )}

                                        <div className="col-6 pt-3 text-left">
                                            <Checkbox
                                                id="ctlSendMail"
                                                text="Activar aviso por mail"
                                                checked={this.state.entity.sendMail}
                                                onChange={this.handleInputChange}
                                                smallPrint=""
                                            />
                                        </div>
                                        <div className="col-6 pt-3 text-right">
                                            <label className="pb-10px">{this.state.textSendMailDate}</label>
                                        </div>
                                        <div className="col-12 pt-3 text-left">
                                            <Checkbox
                                                id="ctlConfirmationRequired"
                                                text="Solicitar confirmación de lectura"
                                                checked={this.state.entity.confirmationRequired}
                                                onChange={this.handleInputChange}
                                                smallPrint=""
                                            />
                                        </div>
                                        {this.state.entity.ConfirmationRequired && (
                                        <div className="col-12 pt-3">
                                            <Input
                                                id="ctlConfirmationText"
                                                type="text"
                                                text={"Leyenda de confirmación de lectura (*)"}
                                                defaultValue={this.state.entity.confirmationText}
                                                classes="mb-0"
                                                maxLength="1000"
                                                onChange={this.handleInputChange}
                                                smallPrint="Es el texto que aparecerá junto al check de confirmación de lectura"
                                            />
                                        </div>
                                        )}
                                    </div>
                                    <div className="pb-4 xMensajeAclarativo">
                                        <label className="xMensajeAclarativo">(*) obligatorio</label><br />
                                    </div>
                                 </section>
                                )}
                            
                            </div>
                            <div className="modal-footer">
                                <Button type="button" size="medium-lg" fill="outline" color="secondary" data-dismiss="modal" onClick={() => { this.props.dismiss(false) }}>{COMMON_MODAL_FORM.CLOSE_BUTTON}</Button>
                                {this.state.showForm && this.state.id !== 0 && (
                                    <Button type="button" size="medium-lg" fill="outline" onClick={() => { this.handleSubmit(false) }}>{COMMON_MODAL_FORM.SAVE_BUTTON}</Button>
                                )}
                                {this.state.showForm && this.state.id === 0 && (
                                    <Button type="button" size="medium-lg" fill="outline" onClick={() => { this.handleSubmit(true) }}>{COMMON_MODAL_FORM.GO_BUTTON}</Button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
